import PoliciesAndTermsContainer from './policies-and-terms-container';

export default PoliciesAndTermsContainer;
